// import {createSlice} from '@reduxjs/toolkit';

// const initialState = {
//   image_upload_status: {
//     front_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     front_left_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     left_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     back_left_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     back_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     back_right_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     right_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     front_right_side: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     outer_windshield: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     inner_windshield: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     registrationNo: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     chassis: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     RC: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     odometer: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     front_left_tyre: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     back_left_tyre: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     back_right_tyre: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     front_right_tyre: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     cng: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//     selfie: {
//       sql_upload_status: 0,
//       azure_img_upload_status: 0,
//     },
//   },
// };

// const image_upload_slice = createSlice ({
//   name: 'image_upload_status',
//   initialState,
//   reducers: {
//     set_image_upload_status: (state, action) => {
//       const { image_name, status, type } = action.payload;
//       console.log(image_name,status,type,"90")
//       // console.log(state.image_upload_status[image_name][type],"90")
//       if (state.image_upload_status[image_name]) {
//         state.image_upload_status[image_name][type] = status;
//         console.log(state.image_upload_status[image_name][type],"94")
//       } else {
//         console.warn(`Image type ${image_name} does not exist in the state.`);
//       }
//     },
//   },
// });

// export const {set_image_upload_status} = image_upload_slice.actions;

// export default image_upload_slice.reducer;
import { createSlice } from "@reduxjs/toolkit";

const makeStatus = () => ({
  sql_upload_status: 0,
  azure_img_upload_status: 0, // keep for backward compatibility
  s3_img_upload_status: 0,    // add since you're dispatching this
});

const initialState = {
  image_upload_status: {
    front_side: makeStatus(),
    front_left_side: makeStatus(),
    left_side: makeStatus(),
    back_left_side: makeStatus(),
    back_side: makeStatus(),
    back_right_side: makeStatus(),
    right_side: makeStatus(),
    front_right_side: makeStatus(),
    outer_windshield: makeStatus(),
    inner_windshield: makeStatus(),
    registrationNo: makeStatus(),
    chassis: makeStatus(),
    RC: makeStatus(),
    odometer: makeStatus(),
    front_left_tyre: makeStatus(),
    back_left_tyre: makeStatus(),
    back_right_tyre: makeStatus(),
    front_right_tyre: makeStatus(),
    cng: makeStatus(),
    selfie: makeStatus(),

    // ✅ NEW cattle keys (to stop your warnings)
    body: makeStatus(),
    muzzle_1: makeStatus(),
    muzzle_2: makeStatus(),
    muzzle_3: makeStatus(),
    aadhar_card: makeStatus(),
    aadhar_card_back_side: makeStatus(),
    // if you upload this too, add it:
    // ear_tag_forehead: makeStatus(),
    // or if you actually send "ear_tag+forehead" (with +), use that exact key:
    // "ear_tag+forehead": makeStatus(),
  },
};

const image_upload_slice = createSlice({
  name: "image_upload_status",
  initialState,
  reducers: {
    set_image_upload_status: (state, action) => {
      const { image_name, status, type } = action.payload;

      // ✅ Auto-create missing image types so you never edit initialState again
      if (!state.image_upload_status[image_name]) {
        state.image_upload_status[image_name] = makeStatus();
      }

      // ✅ Guard unknown status types (prevents silent bugs)
      if (!(type in state.image_upload_status[image_name])) {
        console.warn(
          `Upload status type "${type}" is not defined for "${image_name}". ` +
            `Allowed: ${Object.keys(state.image_upload_status[image_name]).join(", ")}`
        );
        return;
      }

      state.image_upload_status[image_name][type] = status;
    },
  },
});

export const { set_image_upload_status } = image_upload_slice.actions;
export default image_upload_slice.reducer;
